import React, { Component } from 'react';
import './matrix.css';

class ChartMatrix extends Component {
	constructor(props) {
		super(props);
		
		this.draw = this.draw.bind( this );
		
		this.state = {
			"classes": [ "empty", "lowest", "low", "medium", "high", "highest" ],
			"loading": true,
			"levels": {}
		}
	}
	
	componentDidMount() {
		this.draw();
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.Matrix !== this.props.Matrix ) {
			this.draw();
		}
	}
	
	draw() {	
		var levels = {};
		let classes = this.state.classes;
		let min = this.props.Min; 
		let range = Math.round( (this.props.Max - this.props.Min) / ( this.state.classes.length - 1 ) );
		let matrix = this.props.Matrix;
		let axis = this.props.Axis;
		
		axis.forEach(
			function( row ) {
				levels[row.slug] = {};
				axis.forEach(
					function( col ) {
						if ( col.slug === row.slug) {
							levels[row.slug][col.slug] = "self";
						} else {
							levels[row.slug][col.slug] = classes[ ( Math.ceil( ( matrix[row.slug][col.slug] - min ) / range ) ) - 1 ];
						}
					}
				)
			}
		);
		
		this.setState( {
			"levels": levels,
			"ready": true
		} );
		
	}
	
	render() {
		if ( this.state.ready ) {
			let Axis = this.props.Axis;
			let Levels = this.state.levels;
			return (
				<div className="chart-matrix" id={"chart-matrix-" + this.props.ChartId}>
					<div className="chart-matrix-table-wrapper">
						<table>
							<thead>
							<tr>
								<th></th>
								{
									Axis.map(
										function ( item , index ) {
											return <th key={"header-" + index}><div>{item.name}</div></th>
										}
									)
								}
							</tr>
							</thead>
							<tbody>
								{
									Axis.map(
										function ( row , index ) {
											return (
												<tr key={"row-" + index}>
													<th>{row.name}</th>
													{
														Axis.map(
															function ( cell , index ) {
																return <td key={"cell-" + index} className={"cell cell-level-" + Levels[row.slug][cell.slug]}><div></div></td>
															}
														)
													}
												</tr>
											);
										}
									)
								}
							</tbody>
						</table>
						<table className="chart-matrix-legend">
							<tbody>
								<tr>
									<td className="cell cell-level-empty"><div></div></td>
									<td className="cell cell-level-lowest"><div></div></td>
									<td className="cell cell-level-low"><div></div></td>
									<td className="cell cell-level-medium"><div></div></td>
									<td className="cell cell-level-high"><div></div></td>
									<td className="cell cell-level-highest"><div></div></td>
								</tr>
								<tr>
									<td>-</td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td>+</td>
								</tr>
							</tbody>
						</table>
						
					</div>
				</div>
			)
		} else {
			return null;
		}
	}
}

export default ChartMatrix;


// WEBPACK FOOTER //
// ./src/Elezioni/charts/matrix.js